export default "__VITE_ASSET__DFtE$2d3__"